import { render } from "./RegistrationLinkException.vue?vue&type=template&id=76d4ecae&ts=true"
import script from "./RegistrationLinkException.vue?vue&type=script&lang=ts"
export * from "./RegistrationLinkException.vue?vue&type=script&lang=ts"

import "./RegistrationLinkException.vue?vue&type=style&index=0&id=76d4ecae&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__